export const AUTOALBUM_ORIG_NAME = 'album'
export const AUTOALBUM = 'autoalbum'
